import { ICalendarDate } from '../types';

export function formatDate(date: Date): ICalendarDate {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
}
